import scss from 'emun.activity/activity-calendar.scss'
import templateUrl from 'emun.activity/activity-calendar.htm'
import ActivityPrompt from 'emun.activity/activity-prompt'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'
import activityConfig from 'emun.activity/activity.config'

class ActivityCalendarController {
	constructor($scope) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.activityConfig = activityConfig;
		$ctrl.eventClicked = function (event) {
			let $ctrl = this;
			ActivityPrompt.open({ model: { activity: event._activity } }).then(() => $ctrl.load());
		};
		$ctrl.timespanClicked = function (date) {
			$ctrl.lastDateClicked = date;
		};
		$ctrl.bus = new ServiceBus();
		let $rootScope = resolve('$rootScope');
		$rootScope.$on('activitySaved', () => $ctrl.query.load(true));
		$rootScope.$on('activityDeleted', () => $ctrl.query.load(true));
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.calendarView = 'month';
		$ctrl.viewDate = moment();
		$ctrl.events = [];

		$ctrl.activityTypes = new AutoQuery({
			url: 'QueryActivityTypes.json',
			orderBy: 'Type',
			autoLoad: true,
			pageSize: 1000
		});

		$ctrl.query = new AutoQuery({
			url: 'QueryActivitiesJoin.json?v=12345',
			criteria: {
				dateRange: "calendar",
				scheduledForUserName: $session.userName,
				retailerId: $ctrl.customer && $ctrl.customer.id,
				prospectId: $ctrl.prospect && $ctrl.prospect.id,
				type: $ctrl.activityType,
				take: 3000
			},
			filters: [
				{ groupBy: 'Type' },
				{ groupBy: 'ScheduledForFullName' },
				{ date: 'StartDate', title: 'Start Date' },
				{ date: 'EndDate', title: 'End Date' },
				{ groupBy: 'ShowCode' },
				{ groupBy: 'Type' }
			],
			filterOpen: false && $ctrl.$pageConfig.is('gt-sm'),
			orderBy: '-StartDate,Id',
			sortOptions: {
				'Id': 'Id #: Low to High',
				'-Id': 'Id #: High to Low',
				'Status,Id': 'Status: A to Z',
				'-Status,Id': 'Status: Z to A',
				'Title,Id': 'Title: A to Z',
				'-Title,Id': 'Title: Z to A',
				'ScheduledForFullName,Id': 'Scheduled For: A to Z',
				'-ScheduledForFullName,Id': 'Scheduled For: Z to A',
				'CustomerName,Id': 'Company: A to Z',
				'-CustomerName,Id': 'Company: Z to A',
				'Contact,Id': 'Contact: A to Z',
				'-Contact,Id': 'Contact: Z to A',
				'ShowCode,Id': 'Show Code: Low to High',
				'-ShowCode,Id': 'Show Code: High to Low',
				'StartDate,Id': 'Start Date: Newest',
				'-StartDate,Id': 'Start Date: Oldest',
				'EndDate,Id': 'End Date: Newest',
				'-EndDate,Id': 'End Date: Oldest',
				'Type,Id': 'Type: A to Z',
				'-Type,Id': 'Type: Z to A'
			},
			autoLoad: true,
			onLoaded: function (args) {
				$ctrl.events = [];
				args.results.forEach(function (activity) {
					$ctrl.events.push(
						{
							_activity: activity,
							title: activity.title || activity.customerName || activity.prospectName, // The title of the event
							startsAt: new Date(activity.startDate),
							endsAt: new Date(activity.endDate),
							color: { // can also be calendarConfig.colorTypes.warning for shortcuts to the deprecated event types
								primary: '#4fa8d9', //'#e3bc08', // the primary event color (should be darker than secondary)
								secondary: '#d9edf7' // the secondary event color (should be lighter than primary)
							},
							actions: [{ // an array of actions that will be displayed next to the event title
								label: '<i class=\'glyphicon glyphicon-pencil\'></i>', // the label of the action
								cssClass: 'edit-action', // a CSS class that will be added to the action element so you can implement custom styling
								onClick: function (args) { // the action that occurs when it is clicked. The first argument will be an object containing the parent event
									ActivityPrompt.open({ model: { activity: args.calendarEvent._activity } });
								}
							}],
							draggable: true, //Allow an event to be dragged and dropped
							resizable: false, //Allow an event to be resizable
							incrementsBadgeTotal: true, //If set to false then will not count towards the badge total amount on the month and year view
							cssClass: 'a-css-class-name', //A CSS class (or more, just separate with spaces) that will be added to the event when it is displayed on each view. Useful for marking an event as selected / active etc
							allDay: false, // set to true to display the event as an all day event on the day view
							isComplete: activity.isComplete
						}
					);
				});
			}
		});
		$ctrl.onTextClick = function ($event) {
			$event.target.select();
		};
		$ctrl.onTextChange = function ($event) {
			const $ctrl = this;
			if ($ctrl.userName === null) {
				$ctrl.query.criteria.scheduledForUserName = $session.userName;
				$ctrl.load();
			}
		};
		$ctrl.clearSearch = function () {
			const $ctrl = this;
			$ctrl.userName = $session.userName;
			$ctrl.allUsers = "";
			$ctrl.query.criteria.scheduledForUserName = $session.userName;
			$ctrl.load();
		};
	}

	create() {
		let $ctrl = this;
		ActivityPrompt.open({ model: { defaultStarDate: $ctrl.lastDateClicked } }).then(() => $ctrl.load());
	}
	load() {
		const $ctrl = this;
		$ctrl.query.load(true);
	}

	selectActivityType() {
		const $ctrl = this;
		$ctrl.query.criteria.type = $ctrl.activityType;
		$ctrl.load();
	}

	selectAllUsers() {
		const $ctrl = this;
		if ($ctrl.allUsers == "All") {
			$ctrl.query.criteria.scheduledForUserName = null;
		} else {
			$ctrl.userName = $session.userName;
			$ctrl.query.criteria.scheduledForUserName = $session.userName;
		}
		
	  $ctrl.query.criteria.take = 1500;
		$ctrl.load();
	}

	selectUser(user) {
		const $ctrl = this;
		//console.info("user.userName", user);
		//console.info("user.userName", $ctrl.userName);
		$ctrl.query.criteria.scheduledForUserName = user.userName;
		$ctrl.load();
	}

	findUsers(val) {
		const $ctrl = this;
		if (val.length > 1) {
			let url = `QueryNonRetailerUsers.json?Take=5&Search=${val}&OrderBy=FullName`;
			return $ctrl.bus.send(url).then((res) => res.data.results);
		}
	}
	updateActivity(event, newStart, newEnd) {
		const $ctrl = this;
		event.startsAt = newStart;
		event.endsAt = newEnd;
		event._activity.startDate = newStart;
		event._activity.endDate = newEnd;
		$ctrl.bus.send('UpdateActivity.json', event._activity).then(function (response) {
		});
	}
}

let ActivityCalendar = {
	bindings: {
		customer: '<?',
		prospect: '<?',
		hideAdd: '<'
	},
	controller: ActivityCalendarController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default ActivityCalendar;